import React from 'react';
import { applicantStore } from 'ats/pages/applicants/ApplicantStore';
import ApplicantStageIndicator from 'ats/components/applicant-stage-indicator/ApplicantStageIndicator';
import JobApplicationStageIcon from 'ats/components/job-application-stage-icon/JobApplicationStageIcon';
import { getJobApplicationStageTheme } from 'ats/constants/jobApplicationStageTheme';
import { groupsFromStatusOptions } from './stageFilterOptions';

// Pre Hiring, Offer, and Onboarding stay `pre_hired` in the application
// status model; this filter places them under Active.
export const JOB_APPLICATION_STAGE_FILTER_GROUPS = [
	{
		value: 'active',
		label: 'Active',
		stages: [
			'internal_review',
			'presented',
			'client_assessment',
			'client_definition',
			'pre_hiring',
			'offer',
			'onboarding'
		]
	},
	{
		value: 'hired',
		label: 'Hired',
		stages: ['hired']
	},
	{
		value: 'withdrawn',
		label: 'Withdrawn',
		stages: ['unresponsive', 'not_interested']
	},
	{
		value: 'on_hold',
		label: 'On Hold',
		stages: ['on_hold_by_talent', 'on_hold_by_candidate', 'on_hold_by_client']
	},
	{
		value: 'rejected',
		label: 'Rejected',
		stages: [
			'rejected_by_client',
			'rejected_by_recruiter',
			'rejected_by_manager'
		]
	}
];

export const JOB_APPLICATION_STATUS_GROUP_MAP = {
	active: 'active',
	pre_hired: 'active',
	hired: 'hired',
	withdrawn: 'withdrawn',
	on_hold: 'on_hold',
	rejected: 'rejected'
};

export const APPLICANT_STAGE_FILTER_GROUPS = groupsFromStatusOptions(
	applicantStore.statusOptions
);

export function getJobApplicationValueColor(option) {
	return getJobApplicationStageTheme(option.value).color;
}

export function renderJobApplicationValueIcon(option) {
	return <JobApplicationStageIcon stage={option.value} />;
}

export function getApplicantValueColor() {
	return '#1D222B';
}

export function renderApplicantValueIcon(option) {
	const statusValue = applicantStore.stageToStatus[option.value];
	const status = applicantStore.statusOptions.find(
		item => item.value === statusValue
	);

	return (
		<ApplicantStageIndicator
			stageLabel={option.label}
			statusLabel={status?.label}
			stageLevel={option.level}
			statusColor={status?.color}
			showTooltip={false}
			size={14}
			strokeWidth={2.5}
		/>
	);
}

export function renderJobApplicationStage(option) {
	const theme = getJobApplicationStageTheme(option.value);
	return (
		<>
			<JobApplicationStageIcon stage={option.value} />
			<span
				className="stage-filter-dropdown__stage-label"
				style={{ color: theme.color }}>
				{option.label}
			</span>
		</>
	);
}

export function renderApplicantStage(option) {
	const statusValue = applicantStore.stageToStatus[option.value];
	const status = applicantStore.statusOptions.find(
		item => item.value === statusValue
	);

	return (
		<>
			<ApplicantStageIndicator
				stageLabel={option.label}
				statusLabel={status?.label}
				stageLevel={option.level}
				statusColor={status?.color}
				showTooltip={false}
			/>
			<span className="stage-filter-dropdown__stage-label">{option.label}</span>
		</>
	);
}
